import MojitoCore from 'mojito/core';
import PriceBoostsLeagueImpl from './price-boosts-league.js';

const { UIPage } = MojitoCore.Presentation;

/**
 * @namespace PriceBoostsLeague
 * @memberof Mojito.Applications.Sports.Pages
 */

export default UIPage('PriceBoostsLeague', PriceBoostsLeagueImpl);
